import React from 'react';
import { TranslateContext, createTranslate } from 'core/translate';

const TranslateProvider = ({ children }) => {
  const messages = {
    chevrolet: 'Chevrolet',
    buick: 'Buick',
    gmc: 'GMC',
    cadillac: 'Cadillac',
    ...window.data.messages
  };
  const translate = createTranslate(() => messages);
  return (
    <TranslateContext.Provider value={translate}>
      {children}
    </TranslateContext.Provider>
  );
};

export default TranslateProvider;
